// contexts/CallContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { ref, onValue, off } from 'firebase/database';
import { useUser } from './UserContext';
import { useDaily, useLocalSessionId, useMeetingState, useParticipantIds } from '@daily-co/daily-react';
import { database } from '../constants/firebase';

const CallContext = createContext();

export const useCall = () => useContext(CallContext);

export const CallProvider = ({ children }) => {
    const { currentUser } = useUser();
    const callObject = useDaily();
    const participantIds = useParticipantIds();
    const localSessionId = useLocalSessionId();

    const meetingState = useMeetingState();

    // Existing states
    const [callStatus, setCallStatus] = useState('idle');

    // ✅ New states
    const [isIncomingCall, setIsIncomingCall] = useState(false);
    const [isOutgoingCall, setIsOutgoingCall] = useState(false);
    const [callRoomUrl, setCallRoomUrl] = useState(null);
    const [callType, setCallType] = useState("audio");
    const [activeCallData, setActiveCallData] = useState(null);
    const [isOnCall, setIsOnCall] = useState(false);
    const [userId, setUserId] = useState(null);


    const value = {
        // existing
        callStatus,
        setCallStatus,
        callObject,
        meetingState,

        // new
        isIncomingCall,
        setIsIncomingCall,
        isOutgoingCall,
        setIsOutgoingCall,
        callRoomUrl,
        setCallRoomUrl,
        callType,
        setCallType,
        activeCallData,
        setActiveCallData,
        isOnCall,
        setIsOnCall,
        participantIds,
        localSessionId,
        setUserId,
        userId
    };

    return (
        <CallContext.Provider value={value}>
            {children}
        </CallContext.Provider>
    );
};
